import { render } from "./IsinAndCfiPage.vue?vue&type=template&id=5a8f0176"
import script from "./IsinAndCfiPage.vue?vue&type=script&lang=js"
export * from "./IsinAndCfiPage.vue?vue&type=script&lang=js"

import "./IsinAndCfiPage.vue?vue&type=style&index=0&id=5a8f0176&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__